import { useContext } from 'react';
import { FullPageLoaderContex } from 'providers/FullPageLoaderProvider';
import type { ContextProps } from 'providers/FullPageLoaderProvider';

export function useFullPageLoader(): ContextProps {
  const { setLoader } = useContext(FullPageLoaderContex);

  return { setLoader };
}
